export default function getMeasureMappings(): any {
  const measureMappings: any = {};
  measureMappings.JVP1 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.JVP2 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.JVP3 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.JVP4 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.JVP6 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.JVP7 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.JVP8 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.JVP9 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.JVP10 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.JVP11 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.JVP12 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.JVP13 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.PVP0 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.PVP1 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.PVP2 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.PVP3 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.PVP4 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.PVP5 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.PVP6 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.PVP7 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.PVP8 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.PVP9 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.PVP10 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.PVP11 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.PVP12 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.PVP13 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.SVP1 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.SVP2 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.SVP3 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.SVP4 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.SVP5 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.SVP6 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.SVP7 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.SVP8 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.SVP9 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.SVP10 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.SVP11 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.SVP12 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  measureMappings.SVP13 = [
    {name: 'JVP01.FI01_X', description: 'Virtausmittaus', quality: 'm3/h', active: false},
    {name: 'JVP01.PU01_KA_LASK', description: 'Pumppu 1 käyntitieto', quality: 's', active: false},
    {name: 'JVP01.LIA01_X', description: 'Säiliö 1 pinnanmittaus', quality: 'm', active: false},
    {name: 'JVP01.FIQ02_X', description: 'Pumppaamo ylivuoto virtausmittaus', quality: 'm', active: false},
    {name: 'JVP01.TE01_X', description: 'Tuloveden lämpötila', quality: '°C', active: false},
    {name: 'JVP01.QTI03_X', description: 'Ferrosulfaatin pitoisuusmittaus', quality: 'mg/l', active: false},
  ];
  return measureMappings;

}
